// Всё, что касается страницы статьи
const bodyContainer = document.querySelector(".body-container");
const modalButtons = document.querySelectorAll(".blog-page__modal-button");
const modal = document.querySelector(".form-modal");

if (modalButtons) {
  modalButtons.forEach((it) => {
    it.addEventListener("click", (evt) => {
      evt.preventDefault();
      modal.querySelector("#page_link").value = window.location.href;
      modal.querySelector("#form_type").value = it.innerText;
      modal.classList.add("site-modal--opened");
      bodyContainer.classList.add("body-container--no-scroll");
    });
  });
}
